import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})

export class RegistrationCustomerLicenseNames {
    static readonly TinyMce = '550035';
    static readonly InteliChartPatientPortal = '540074';
}
